import { render } from "./InsuranceQuestionnaire.vue?vue&type=template&id=616710f2&scoped=true&lang=pug"
import script from "./InsuranceQuestionnaire.vue?vue&type=script&lang=js"
export * from "./InsuranceQuestionnaire.vue?vue&type=script&lang=js"

import "./InsuranceQuestionnaire.vue?vue&type=style&index=0&id=616710f2&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616710f2"]])

export default __exports__